(() => {
  if (window.__nueProductCustomizationUiReady) return;
  window.__nueProductCustomizationUiReady = true;

  const enhancedBlocks = new WeakSet();

  const findScope = (block) =>
    block.closest('[data-testid="product-information-details"], product-information, .product-information, section') ||
    document;

  const shouldHideAcceleratedCheckout = (block) => {
    if (block.matches('nue-customization-upload')) {
      return block.dataset.hideDynamicCheckout !== 'false';
    }

    return Boolean(block.querySelector('input[type="file"]'));
  };

  const hideAcceleratedCheckout = (block) => {
    if (!shouldHideAcceleratedCheckout(block)) return;

    // File uploads conflict with accelerated checkout.
    const scope = findScope(block);
    scope.querySelectorAll('.accelerated-checkout-block, shopify-accelerated-checkout, .shopify-payment-button').forEach((checkout) => {
      checkout.hidden = true;
      checkout.style.setProperty('display', 'none', 'important');
      checkout.dataset.hiddenForCustomizationUpload = 'true';
    });
  };

  const syncActivePreviewSlots = (block) => {
    let hasFiles = false;

    block.querySelectorAll('[data-preview-slot]').forEach((slot) => {
      const preview = slot.querySelector('[data-preview-image]');
      const fileInput = block.querySelector(`[data-file-slot="${slot.dataset.previewSlot}"]`);
      const filled = Boolean(
        (fileInput instanceof HTMLInputElement && fileInput.files?.length) ||
          (preview instanceof HTMLImageElement && preview.src && !preview.hidden)
      );

      slot.classList.toggle('is-filled', filled);
      if (preview instanceof HTMLImageElement) preview.hidden = !filled;
      hasFiles ||= filled;
    });

    block.querySelectorAll('[data-image-slot]').forEach((slot) => {
      const input = slot.querySelector('[data-customization-image]');
      const preview = slot.querySelector('[data-image-preview]');
      const filled = Boolean(
        input instanceof HTMLInputElement &&
          input.files?.length &&
          preview instanceof HTMLImageElement &&
          preview.src &&
          !preview.hidden
      );

      slot.classList.toggle('is-filled', filled);
      if (preview instanceof HTMLImageElement) preview.hidden = !filled;
      hasFiles ||= filled;
    });

    block.classList.toggle('has-files', hasFiles);
  };

  const enhanceBlock = (block) => {
    if (!(block instanceof HTMLElement)) return;

    hideAcceleratedCheckout(block);
    syncActivePreviewSlots(block);

    if (enhancedBlocks.has(block)) return;
    enhancedBlocks.add(block);

    const refresh = () => {
      requestAnimationFrame(() => {
        syncActivePreviewSlots(block);
        hideAcceleratedCheckout(block);
      });
    };

    block.addEventListener('change', refresh);
    block.addEventListener('click', refresh);
    block.addEventListener('drop', refresh);

    const observer = new MutationObserver(refresh);
    observer.observe(block, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['hidden', 'src'],
    });
    block.__nueCustomizationObserver = observer;
  };

  const scan = (root = document) => {
    if (root instanceof Element && root.matches('nue-customization-upload, product-customization-upload')) {
      enhanceBlock(root);
    }

    root.querySelectorAll?.('nue-customization-upload, product-customization-upload').forEach(enhanceBlock);
  };

  scan(document);
  document.addEventListener('shopify:section:load', (event) => scan(event.target));

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node instanceof Element) scan(node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
